import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  SofiaMark,
} from "@coval/ui"

import type { Notebook } from "../utils/notebookSnapshot"
import { NotebookCanvas } from "./NotebookCanvas"

export function NotebookConflictDialog({
  open,
  onClose,
  latest,
  organizationSlug,
  workspaceId,
  saving,
  loading,
  onUseSaved,
  onSaveDraft,
  onRetry,
}: {
  open: boolean
  onClose: () => void
  latest: Notebook | null
  organizationSlug: string
  workspaceId: string
  saving: boolean
  loading: boolean
  onUseSaved: () => void
  onSaveDraft: () => Promise<boolean>
  onRetry: () => Promise<void>
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => !value && !saving && onClose()}
    >
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>Review the saved version</DialogTitle>
        </DialogHeader>
        <DialogBody className="max-h-[65vh] overflow-y-auto">
          <p className="mb-4 text-sm text-coval-text-muted">
            Your draft is still in the editor. Compare it with this saved
            version before choosing which to keep. Saving your draft creates a
            new version.
          </p>
          {latest ? (
            <>
              {latest.locked && (
                <p>
                  This notebook is now locked. You can use the saved version.
                </p>
              )}
              <NotebookCanvas
                headingOffset={2}
                notebook={latest}
                organizationSlug={organizationSlug}
                workspaceId={workspaceId}
              />
            </>
          ) : (
            <div className="flex items-center gap-3">
              {loading && <SofiaMark size={24} animated />}
              <Button
                variant="secondary"
                disabled={loading}
                onClick={() => void onRetry()}
              >
                Load saved version
              </Button>
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Keep editing my draft
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onUseSaved()
              onClose()
            }}
            disabled={!latest || saving}
          >
            Use saved version
          </Button>
          <Button
            onClick={() =>
              void onSaveDraft().then((saved) => {
                if (saved) {
                  onClose()
                }
              })
            }
            disabled={!latest || latest.locked || saving}
          >
            Save my draft instead
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
